import { Skeleton, VStack, cn } from "@jace/ui";
import { ReactNode } from "react";

const sharedClass = `h-[14px]`;

interface EmailDraftSkeletonProps {
	lines: number[];
}

interface LineSkeletonProps {
	width?: string;
	className?: string;
}

export function LineSkeleton({
	width = "100%",
	className,
}: LineSkeletonProps): React.ReactElement {
	return (
		<div
			className={cn(
				"overflow-hidden rounded-full bg-surface  max-w-full",
				sharedClass,
				className,
			)}
			style={{ width }}
		>
			<Skeleton />
		</div>
	);
}

export function EmptyLine(): React.ReactElement {
	return <div className={cn("w-full bg-transparent", sharedClass)} />;
}

export function EmailChromaSkeleton({ children }: { children: ReactNode }) {
	return (
		<div className="mx-auto my-xl w-full max-w-feed p-lg">
			<div className={cn("hover:bg-jace", "p-[1px]", "rounded-message")}>
				<div
					className={cn(
						"border border-message-email-border",
						"text-md text-text-body",
						"bg-input-background",
						"overflow-hidden",
						"rounded-message",
					)}
				>
					<div
						className={cn(
							"h-[40px] flex w-full items-center justify-center bg-black/10 px-sm",
						)}
					>
						<LineSkeleton width="64%" className="bg-[rgba(255,255,225,0.02)]" />
					</div>

					<div className="p-lg">{children}</div>
				</div>
			</div>
		</div>
	);
}

export function EmailDraftSkeleton({
	lines,
}: EmailDraftSkeletonProps): React.ReactElement {
	return (
		<VStack className="gap-md py-lg">
			{lines.map((l, i) =>
				l === -1 ? (
					<EmptyLine key={`${i}-${Math.abs(l)}`} />
				) : (
					<LineSkeleton key={`${Math.abs(l)}-${i}`} width={`${l * 100}%`} />
				),
			)}
		</VStack>
	);
}
